import { confirmPromptConstants } from '../_constants';

export const confirmPromptActions = {
    show,
    hide
};

function show(title, description, actionText) {
    return { type: confirmPromptConstants.SHOW, title, description, actionText };
}

function hide() {
    return { type: confirmPromptConstants.HIDE };
}